"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function noBatchUpdates(fn) {
    return fn();
}
function isFunction(fn) {
    return typeof fn === 'function';
}
var batchUpdates = noBatchUpdates;
Promise.resolve().then(function () { return __importStar(require('./batchedUpdates')); }).then(function (r) {
    if (isFunction(r.unstable_batchedUpdates)) {
        batchUpdates = r.unstable_batchedUpdates;
    }
}, function () { });
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null)
        return false;
    var proto = obj;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
}
var Rekv = (function () {
    function Rekv(initState, options) {
        var _this = this;
        this.delegate = {};
        this._events = {};
        this._updateId = 0;
        this._state = {};
        this._inDelegate = false;
        this.useState = function () {
            var keys = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                keys[_i] = arguments[_i];
            }
            var _a = __read(react_1.useState(function () {
                var v = {};
                keys.forEach(function (key) {
                    v[key] = _this._state[key];
                });
                return v;
            }), 2), value = _a[0], setValue = _a[1];
            react_1.useEffect(function () {
                var updater = function () {
                    var v = {};
                    keys.forEach(function (key) {
                        v[key] = _this._state[key];
                    });
                    setValue(v);
                };
                keys.forEach(function (key) {
                    _this.on(key, updater);
                });
                return function () {
                    keys.forEach(function (key) { return _this.off(key, updater); });
                };
            }, keys);
            return value;
        };
        if (!isPlainObject(initState)) {
            throw new Error('init state is not a plain object');
        }
        this._state = initState;
        var effects = {};
        if (options && options.effects) {
            Object.keys(options.effects).forEach(function (key) {
                var func = options.effects[key];
                effects[key] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return func.call.apply(func, __spread([_this], args));
                };
            });
        }
        this.effects = effects;
    }
    Rekv.prototype.on = function (name, callback) {
        var s = this._events[name];
        if (!s) {
            this._events[name] = [callback];
        }
        else if (s.indexOf(callback) < 0) {
            s.push(callback);
        }
    };
    Rekv.prototype.off = function (name, callback) {
        var s = this._events[name];
        if (s) {
            var index = s.indexOf(callback);
            if (index >= 0) {
                s.splice(index, 1);
            }
        }
    };
    Rekv.prototype.setState = function (param) {
        var _this = this;
        var kvs;
        if (isFunction(param)) {
            kvs = param(this._state);
        }
        else {
            kvs = param;
        }
        if (!this._inDelegate) {
            this._inDelegate = true;
            if (this.delegate && isFunction(this.delegate.beforeUpdate)) {
                var ret = this.delegate.beforeUpdate({ store: this, state: kvs });
                if (ret) {
                    kvs = ret;
                }
            }
            if (Rekv.delegate && isFunction(Rekv.delegate.beforeUpdate)) {
                var ret = Rekv.delegate.beforeUpdate({ store: this, state: kvs });
                if (ret) {
                    kvs = ret;
                }
            }
            this._inDelegate = false;
        }
        if (!isPlainObject(kvs)) {
            throw new Error('setState() only receive an plain object');
        }
        var keys = Object.keys(kvs);
        var needUpdateKeys = [];
        var updatedValues = {};
        keys.forEach(function (key) {
            if (_this._state[key] !== kvs[key]) {
                needUpdateKeys.push(key);
                updatedValues[key] = kvs[key];
                _this._state[key] = kvs[key];
            }
        });
        this.updateComponents.apply(this, __spread(needUpdateKeys));
        if (!this._inDelegate) {
            this._inDelegate = true;
            if (this.delegate && isFunction(this.delegate.afterUpdate)) {
                this.delegate.afterUpdate({ store: this, state: updatedValues });
            }
            if (Rekv.delegate && isFunction(Rekv.delegate.afterUpdate)) {
                Rekv.delegate.afterUpdate({ store: this, state: updatedValues });
            }
            this._inDelegate = false;
        }
    };
    Rekv.prototype.classUseState = function (component) {
        var _this = this;
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        var ret = {};
        var unmount = component.componentWillUnmount;
        var updater = function () {
            component.forceUpdate();
        };
        keys.forEach(function (key) {
            _this.on(key, updater);
            Object.defineProperty(ret, key, {
                get: function () { return _this._state[key]; },
            });
        });
        component.componentWillUnmount = function () {
            keys.forEach(function (key) {
                _this.off(key, updater);
            });
            if (isFunction(unmount)) {
                unmount.call(component);
            }
        };
        return ret;
    };
    Object.defineProperty(Rekv.prototype, "currentState", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    Rekv.prototype.getCurrentState = function () {
        return this._state;
    };
    Rekv.prototype.updateComponents = function () {
        var _this = this;
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        if (keys.length <= 0) {
            return;
        }
        batchUpdates(function () {
            keys.forEach(function (key) {
                var updaters = _this._events[key];
                if (Array.isArray(updaters)) {
                    updaters.forEach(function (updater) {
                        if (updater.updateId !== _this._updateId) {
                            updater.updateId = _this._updateId;
                            updater(_this._state[key]);
                        }
                    });
                }
            });
        });
        this._updateId++;
        if (this._updateId >= 2147483647) {
            this._updateId = 0;
        }
    };
    Rekv.delegate = {};
    return Rekv;
}());
exports.Rekv = Rekv;
exports.default = Rekv;
exports.globalStore = new Rekv({});
